module.exports = __webpack_public_path__ + "img/notification.13fb91ae.svg";